<template>Ukážka pridania druhého modulu</template>
